import React from 'react';
import PropTypes from 'prop-types';
import Price from './price';

const ProductCard = ({ item }) => (
  <div className="recent-product-card mx-1" style={{ border: '1px solid #eee' }}>
    <a
      href={item.url}
      className="d-flex flex-column h-100 px-2"
      aria-label={item.ariaLabel}
      role="link">
      <div className="card-image thumbnail">
        <div className="product-image d-flex align-items-center">
          <img className="image-fluid m-auto" src={item.image} alt={item.title} />
        </div>
      </div>
      <div className="align-content-end card-body p-0">
        <div className="product-information d-flex flex-column text-left mb-3">
          {item.subtitle && <span>{item.subtitle}</span>}
          <span>{item.title}</span>
          <strong>
            <Price now={item.price} includeFrom={item.includeFrom} />
          </strong>
        </div>
      </div>
      <span
        className="btn btn-primary m-2 view-recent-product"
        aria-hidden="true">
        View Product
      </span>
    </a>
  </div>
);

export const itemType = PropTypes.shape({
  key: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  url: PropTypes.string.isRequired,
  image: PropTypes.string,
  price: PropTypes.number.isRequired,
  includeFrom: PropTypes.bool,
  ariaLabel: PropTypes.string.isRequired,
});

ProductCard.propTypes = { item: itemType.isRequired };

export default ProductCard;
